import hero from "../../Images/NorthTable/nt-hero.jpg";

const northTableData = {
  heroImage: hero,
  title: "The North Table",
  projectType: "Web Design // Food Truck + Catering",
  subtitle: [
    <>
      <a href="https://thenorthtable.com" target="_blank" rel="noopener noreferrer">
        thenorthtable.com
      </a>
    </>,
  ],
  overview:
    "The North Table is an up-and-coming food truck and catering service, set to open later this year in Grand Marais, Minnesota. I had the chance to design and create their website (using Squarespace), which features their menu, story, and contact information.",

  tabs: [],
};

export default northTableData;
